import { ILocationPath, Location } from './location';
import { AzureBlobStorageLinkedService } from '../../linkedservice/azure-blob-storage.linkedservice';
import { Metamodel } from '../../base/model';
import { IAttribute, IModel, IViolation } from '../../base/annotation';
import { FilePath } from '../file-path';
import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { Constants } from '../../../shared/shared-constants';
import { shellStringResources } from '../../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'AzureBlobStorageLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureBlobStorageLinkedService)
    }
})
export class AzureBlobStorageLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;
    public static readonly CONTAINER: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Container,
        association: 'CONTAINER',
        templatable: true,
        constraint: {
            validator: (owner: Location, value: string): IViolation[] | undefined => {
                if (stringIsNullOrEmpty(value)) {
                    return undefined;
                }
                if (!Constants.blobContainerNameValidation.test(value)) {
                    return [
                        {
                            message: () => shellStringResources.CopyWizard_Dataset_Blob_Sink_ContainerValidationError
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public container?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
        this.container = path.container;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', AzureBlobStorageLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', AzureBlobStorageLocation.FILE_NAME, path);
        this.setPathPropertyValue('container', AzureBlobStorageLocation.CONTAINER, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        path.container = this.container;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: AzureBlobStorageLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: AzureBlobStorageLocation.FILE_NAME.templateValue(this) || this.fileName,
            container: AzureBlobStorageLocation.CONTAINER.templateValue(this) || this.container
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && AzureBlobStorageLocation.FILE_NAME.templateValue(this)
            ? false
            : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(AzureBlobStorageLocation.CONTAINER.templateValue(this)) ||
            !stringIsNullOrEmpty(AzureBlobStorageLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(AzureBlobStorageLocation.FILE_NAME.templateValue(this));
    }
}
